const Kardex = () => import("@/features/dep/kardex/home/presentation/views/KardexTabsView.vue");
const KardexActive = () => import("@/features/dep/kardex/active/presentation/views/KardexActiveView.vue");
const KardexInactive = () => import("@/features/dep/kardex/inactive/presentation/views/KardexInactiveView.vue");
const KardexHistorical = () => import("@/features/dep/kardex/historical/presentation/views/KardexHistoricalView.vue");

export const kardexRoutes = [
    {
        path: '/kardex/:id',
        component: Kardex,
        children: [
            {
                path: '',
                name: 'kardex-active-tab',
                component: KardexActive,
            },
            {
                path: 'inactive',
                name: 'kardex-inactive-tab',
                component: KardexInactive,
            },
            {
                path: 'historical',
                name: 'kardex-historical-tab',
                component: KardexHistorical,
            },
        ],
    },
];
